"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePriceConverters = void 0;
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var utils_1 = require("../../shared/utils");
var index_1 = require("../../pool/hooks/index");
var usePoolTokenPrice_1 = require("../../pool/hooks/usePoolTokenPrice");
var decimals = (0, web3_utils_1.toBN)(1e12);
function usePriceConverters() {
    var price = (0, index_1.usePoolCurrencyUsdPrice)();
    var _a = (0, usePoolTokenPrice_1.usePoolTokenPrice)(), priceUsd = _a.priceUsd, priceCurrency = _a.priceCurrency, rate = _a.rate;
    var currencyToUsd = function (value) {
        return (0, utils_1.currencyToTokens)({ value: value, rate: priceUsd, decimals: decimals });
    };
    var tokensToUsd = function (value, forceRate) {
        return (0, utils_1.toEthN)((0, utils_1.currencyToTokens)({ value: value, rate: forceRate || priceUsd, decimals: decimals }));
    };
    return (0, react_1.useMemo)(function () {
        return {
            currencyToTokens: function (value) {
                return (0, utils_1.currencyToTokens)({ value: value, rate: rate, decimals: decimals });
            },
            tokensToCurrency: function (value, forceRate) {
                return (0, utils_1.tokensToCurrency)({ value: value, rate: forceRate || rate, decimals: decimals });
            },
            usdToCurrency: function (value) { return value / price; },
            currencyToUsd: currencyToUsd,
            tokensToUsd: tokensToUsd,
        };
    }, [priceCurrency.toString(), priceUsd, price]);
}
exports.usePriceConverters = usePriceConverters;
